import Vue from 'vue'
import VueRouter from 'vue-router'
import { fb_auth, fb_users } from '../firebase'
import store from '../store'

// Public Routes
import Public from '../views/Public.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import ForgotPassword from '../views/ForgotPassword.vue'

// default authenticated route
import Layout from '../views/Layout.vue'

// cutomer views
import Orders from '../views/Orders.vue'
import MealSelector from '../views/MealSelector.vue'
import MealDetail from '../views/MealDetail.vue'
import NoMealsOpen from '../views/NoMealsOpen.vue'
import Facility from '../views/Facility.vue'
import AwaitingApproval from '../views/AwaitingApproval.vue'
import Survey from '../views/Survey.vue'


Vue.use(VueRouter)

  const routes = [
  //Public routes
  {
    path: '/',
    name: 'Public',
    component: Public,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: ForgotPassword,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  // Private routes are children of the Layout component
  {
    path: '/layout',
    name: 'Layout',
    //redirect: '/orders',
    component: Layout,
    meta: {
      authReq: true
    },
    children: [
      {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        meta: {
          authReq: true,
          orderRoute: true,
        },
        children: [
          {
            path: '/breakfast',
            name: 'Breakfast',
            component: MealSelector,
            meta: {
              orderRoute: true,
            },
          },
          {
            path: '/breakfast/:id',
            name: 'Breakfast Detail',
            component: MealDetail,
            meta: {
              mealtype: 'breakfast',
              orderRoute: true,
            }
          },
          {
            path: '/lunch',
            name: 'Lunch',
            component: MealSelector,
            meta: {
              orderRoute: true,
            },
          },
          {
            path: '/lunch/:id',
            name: 'Lunch Detail',
            component: MealDetail,
            meta: {
              mealtype: 'lunch',
              orderRoute: true,
            }
          },
          {
            path: '/dinner',
            name: 'Dinner',
            component: MealSelector,
            meta: {
              orderRoute: true,
            },
          },
          {
            path: '/dinner/:id',
            name: 'Dinner Detail',
            component: MealDetail,
            meta: {
              mealtype: 'dinner',
              orderRoute: true,
            }
          },
          {
            path: '/brunch',
            name: 'Brunch',
            component: MealSelector,
            meta: {
              orderRoute: true,
            },
          },
          {
            path: '/brunch/:id',
            name: 'Brunch Detail',
            component: MealDetail,
            meta: {
              mealtype: 'brunch',
              orderRoute: true,
            },
          },
          {
            path: '/supper',
            name: 'Supper',
            component: MealSelector,
            meta: {
              orderRoute: true,
            },
          },
          {
            path: '/supper/:id',
            name: 'Supper Detail',
            component: MealDetail,
            meta: {
              mealtype: 'supper',
              orderRoute: true,
            },
          },
        ]
      },
      {
        path: '/nomeal',
        name: 'No Meal Open',
        component: NoMealsOpen
      },
      {
        path: '/awaitingapproval',
        name: 'Awaiting Approval',
        component: AwaitingApproval
      },
      {
        path: '/facility',
        name: 'Facility',
        component: Facility,
      },
      {
        path: '/survey',
        name: 'Survey',
        component: Survey,
      },
      {
        path: '/kitchen',
        name: 'Kitchen',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Kitchen.vue'),
      },
      {
        path: '/headcount',
        name: 'Head Count',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Cashier.vue'),
      },
      {
      path: '/admin',
      name: 'Admin',
      component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
      },
      {
        path: '/meals',
        name: 'Meals',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Meals.vue'),
      },
      {
        path: '/meals/new',
        name: 'New Meal',
        component: () => import(/* webpackChunkName: "admin" */ '../views/NewMeal.vue'),
      },
      {
        path: '/meals/:id',
        name: 'Edit Meal',
        component: () => import(/* webpackChunkName: "admin" */ '../views/MealEdit.vue'),
      },
      {
        path: '/menu',
        name: 'Menu Editor',
        component: () => import(/* webpackChunkName: "admin" */ '../views/MenuEditor.vue'),
      },
      {
        path: '/hours',
        name: 'Hours',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Hours.vue'),
      },
      {
        path: '/users/:id',
        name: 'Edit Users',
        component: () => import(/* webpackChunkName: "admin" */ '../views/UsersEdit.vue'),
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Users.vue'),
      },
      {
        path: '/profile',
        name: 'User Profile',
        component: () => import(/* webpackChunkName: "user" */ '../views/UserProfile.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users
router.beforeEach(async (to, from, next) => {
  const authReq = to.matched.some(x => x.meta.authReq)
  if (authReq) {
    fb_auth.onAuthStateChanged(user => {
      if (user) {
        next()
      } else {
        next('/login')
      }
    })
  } else {
    next()
  }
})

export default router
